import script from "./LineGame.vue?vue&type=script&setup=true&lang=js"
export * from "./LineGame.vue?vue&type=script&setup=true&lang=js"

import "./LineGame.vue?vue&type=style&index=0&id=d679d2ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d679d2ca"]])

export default __exports__